export default "__VITE_ASSET__084e944d__"